import { BaseDetailPage } from 'src/app/@shared/base-detail-page';
import { Component, Input, inject } from '@angular/core';

import { ClusterModel } from 'src/app/cluster/@shared/cluster.model';
import { DatasetFormCompleteStatus } from 'src/app/@shared/form/base-form.component';
import { ToastService } from 'src/app/@core/toast.service';

@Component({
  selector: 'page-cluster-edit',
  standalone: false,
  styleUrls: ['./cluster-edit.page.scss'],
  templateUrl: './cluster-edit.page.html',
})
export class ClusterEditPage extends BaseDetailPage<ClusterModel> {
  @Input() public item: ClusterModel;

  public readonly pageTrackName = 'ClusterEditPage';

  public isEditMode: boolean;

  protected isStaticPage: boolean = true;

  private toastService = inject(ToastService);

  public onProcessCompleted(processCompleted: DatasetFormCompleteStatus): void {
    switch (processCompleted) {
      case 'submitted':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_SUCCESS.MESSAGE')).catch();
        this.back('submitted').catch();
        break;

      case 'error':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_ERROR.MESSAGE'), {
          color: 'danger',
        }).catch();
        break;

      default:
        this.back('canceled').catch();
        break;
    }
  }

  public async back(role: 'submitted' | 'canceled' = 'canceled'): Promise<void> {
    await this.modalController.dismiss(null, role);

    return Promise.resolve();
  }

  protected protoOnInit(): void {
    this.isEditMode = !!this.item?.id;
  }
}
